/**
 * Inventory Hub API Setup
 * Uses shared @quotech/api bootstrap — see packages/api/src/setupHubApi.ts
 */
export { getConfiguredClient } from '@quotech/api'
import { setupHubApi, getDefaultClient } from '@quotech/api'

/** Call once in main.tsx before rendering. */
export function initializeApi() {
  setupHubApi({ hubName: 'Inventory' })
}

// Export with expected name for main.tsx
export const setupInventoryApi = initializeApi

// Re-export configured client for backward compat
export const apiClient = getDefaultClient()

/**
 * Inventory-specific API endpoints
 */
export const inventoryApi = {
  // Items
  getItems: (params?: Record<string, unknown>) => getDefaultClient().get('/api/inventory/items/', { params }),
  getItem: (id: string) => getDefaultClient().get(`/api/inventory/items/${id}/`),
  createItem: (data: unknown) => getDefaultClient().post('/api/inventory/items/', data),
  updateItem: (id: string, data: unknown) => getDefaultClient().put(`/api/inventory/items/${id}/`, data),

  // Locations
  getLocations: () => getDefaultClient().get('/api/inventory/locations/'),
  getLocation: (id: string) => getDefaultClient().get(`/api/inventory/locations/${id}/`),

  // Stock
  getStock: (itemId: string) => getDefaultClient().get(`/api/inventory/items/${itemId}/stock/`),
  adjustStock: (itemId: string, data: unknown) => getDefaultClient().post(`/api/inventory/items/${itemId}/adjust/`, data),

  // Orders
  getOrders: () => getDefaultClient().get('/api/inventory/orders/'),
  createOrder: (data: unknown) => getDefaultClient().post('/api/inventory/orders/', data),

  // Transfers
  getTransfers: () => getDefaultClient().get('/api/inventory/transfers/'),
  createTransfer: (data: unknown) => getDefaultClient().post('/api/inventory/transfers/', data),

  // Reports
  getStockReport: () => getDefaultClient().get('/api/inventory/reports/stock/'),
  getMovementReport: () => getDefaultClient().get('/api/inventory/reports/movements/'),

  // Alerts
  getLowStockAlerts: () => getDefaultClient().get('/api/inventory/alerts/low-stock/'),
}
